exports.shouldUpdateScroll = () => {
    if (document.querySelector("#___gatsby")) {
        document.querySelector("#___gatsby").scrollTop = 0
    }

    return false;
};